import styles from './ExportingLabel.module.scss';

interface ExportingLabelProps {
    percent: number;
}

// In-flight export label. The percentage reserves a fixed width (sized for
// "100%") and uses tabular figures, so the digit count (1→2→3 chars) counting
// up never reflows the button — keeps the width, caret, and "Exporting…" fixed.
export function ExportingLabel({ percent }: ExportingLabelProps) {
    return (
        <>
            <span className={styles.percent}>{Math.round(percent)}%</span> Exporting…
        </>
    );
}
